import React, { useState } from 'react'
import { Box, CircularProgress, useMediaQuery, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { FeaturedMovie, MovieList, Pagination } from '..';
import { useGetMoviesQuery } from '../../services/TMDB';

const Movies = () => {
  const [page, setPage] = useState(1);
  const { genreIdOrCategoryName, searchQuery } = useSelector((state) => state.currentGenreOrCategory);
  const { data, error, isFetching } = useGetMoviesQuery({genreIdOrCategoryName, page, searchQuery});
  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size='4rem' />
      </Box>
    )
  }
  if (!data.results.length) {
      return (
        <Box display='flex' alignItems='center' mt="20px">
          <Typography variant='h4'>
            No Movies Match with that name
            <br />
            Please Search Something Else
          </Typography>
        </Box>
      )
    }

    if(error) return  'An Error has Occured'

  return (
    <div>

      <FeaturedMovie movie={data.results[0]} />
      <MovieList movies={data} excludeFirst={'1'} />
      <Pagination currentpage={page} setPage={setPage} totalPages={data.total_pages} />
      </div>
  )
}

export default Movies